export default {
  title: 'ประกาศ',
  subtitle: 'สื่อสารกับผู้เช่าของคุณ',
  new_button: 'ประกาศใหม่',
  form: {
    title_label: 'หัวเรื่อง',
    title_placeholder: 'เช่น แจ้งน้ำประปาหยุดจ่าย 15 มี.ค.',
    title_counter: 'เหลือ {{count}} ตัวอักษร',
    body_label: 'เนื้อหา',
    body_hint: 'ข้อความธรรมดาเท่านั้น',
    publish_label: 'วันและเวลาเผยแพร่',
    expires_label: 'วันและเวลาหมดอายุ',
    expires_hint: 'ไม่บังคับ เว้นว่างหากไม่มีวันหมดอายุ',
    target_label: 'กลุ่มเป้าหมาย',
    target_all: 'ผู้เช่าทั้งหมด',
    target_property: 'อาคารเฉพาะ',
    target_unit: 'ห้องเฉพาะ',
    property_label: 'อาคาร',
    unit_label: 'ห้อง',
    save_button: 'บันทึกประกาศ',
    create_success: 'สร้างประกาศแล้ว',
    update_success: 'อัปเดตประกาศแล้ว',
    delete_confirm: 'ลบประกาศนี้? ไม่สามารถย้อนกลับได้',
    delete_success: 'ลบประกาศแล้ว',
  },
  status: { active: 'ใช้งาน', scheduled: 'กำหนดเวลาไว้', expired: 'หมดอายุ' },
  target: { all: 'ผู้เช่าทั้งหมด', property: 'อาคาร', unit: 'ห้อง' },
  detail: { published: 'เผยแพร่', expires: 'หมดอายุ', no_expiry: 'ไม่มีวันหมดอายุ', created_by: 'สร้างโดย' },
  empty: { title: 'ยังไม่มีประกาศ', description: 'สร้างประกาศเพื่อสื่อสารกับผู้เช่า' },
}
